const AUTH_KEY = 'ybit-offline-auth-v1';

const listeners = new Set();

const loadUser = () => {
  if (typeof window === 'undefined') return null;
  const stored = window.localStorage.getItem(AUTH_KEY);
  return stored ? JSON.parse(stored) : null;
};

const saveUser = (user) => {
  if (typeof window === 'undefined') return;
  if (user) {
    window.localStorage.setItem(AUTH_KEY, JSON.stringify(user));
  } else {
    window.localStorage.removeItem(AUTH_KEY);
  }
};

const notify = (auth) => {
  listeners.forEach((callback) => callback(auth.currentUser));
};

const createAuth = () => {
  const auth = {
    currentUser: loadUser(),
    onAuthStateChanged(callback) {
      callback(auth.currentUser);
      listeners.add(callback);
      return () => listeners.delete(callback);
    }
  };

  return auth;
};

let authInstance = null;

export const getAuth = () => {
  if (!authInstance) {
    authInstance = createAuth();
  }
  return authInstance;
};

export const signInAnonymously = async (auth = getAuth()) => {
  const user = {
    uid: `offline_${Date.now().toString(36)}`,
    email: null,
    isAnonymous: true
  };
  auth.currentUser = user;
  saveUser(user);
  notify(auth);
  return { user };
};

export const createUserWithEmailAndPassword = async (auth = getAuth(), email) => {
  const user = {
    uid: email,
    email,
    isAnonymous: false
  };
  auth.currentUser = user;
  saveUser(user);
  notify(auth);
  return { user };
};

export const signOut = async (auth = getAuth()) => {
  auth.currentUser = null;
  saveUser(null);
  notify(auth);
};

export const onAuthStateChanged = (auth = getAuth(), callback) => auth.onAuthStateChanged(callback);

